import { axiosReq } from "utils";
import { CryptoChillActions } from "./CrytochillReducer";

export const createInvoice = (getToken, data) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(CryptoChillActions.createInvoiceLoading());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/payments/create`,
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(CryptoChillActions.createInvoiceSuccess(response?.data));
    } catch (error) {
      dispatch(
        CryptoChillActions.createInvoiceError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};
export const getInvoice = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(CryptoChillActions.getInvoiceLoading());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/payments/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(CryptoChillActions.getInvoiceSuccess(response?.data));
    } catch (error) {
      dispatch(
        CryptoChillActions.getInvoiceError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getInvoiceQr = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(CryptoChillActions.getQRCodeLoading());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/payments/qr/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(CryptoChillActions.getQRCodeSuccess(response?.data));
    } catch (error) {
      dispatch(
        CryptoChillActions.getQRCodeError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getCryptoChillProfile = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(CryptoChillActions.getProfileLoading());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/payments/profile/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(CryptoChillActions.getProfileSuccess(response?.data));
    } catch (error) {
      dispatch(
        CryptoChillActions.getProfileError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const getRates = (getToken) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(CryptoChillActions.getRatesLoading());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/payments/exchangeRates`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(CryptoChillActions.getRatesSuccess(response?.data));
    } catch (error) {
      dispatch(
        CryptoChillActions.getRatesError(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };
};

export const clearAllStatesses = () => {
  return (dispatch) => {
    dispatch(CryptoChillActions.clearAllStatesses());
  };
};

export const clearStates = () => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(CryptoChillActions.clearStates());
    }, 3000);
  };
};
